import React, { createContext, useContext, useState, useEffect } from 'react';
import { getOracleJetConfig } from './oracleJet';

const OracleJetContext = createContext({ config: null, cdnPrefix: null, loading: true });

export function OracleJetProvider({ children }) {
  const [state, setState] = useState({ config: null, cdnPrefix: null, loading: true });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const config = await getOracleJetConfig();
        if (cancelled) return;
        const cdnPrefix = (config.cdns && config.cdns.jet && config.cdns.jet.prefix)
          ? config.cdns.jet.prefix.replace(/\/$/, '')
          : null;
        setState({ config, cdnPrefix, loading: false });
      } catch (_) {
        if (!cancelled) setState({ config: null, cdnPrefix: null, loading: false });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <OracleJetContext.Provider value={state}>
      {children}
    </OracleJetContext.Provider>
  );
}

export function useOracleJetConfig() {
  return useContext(OracleJetContext);
}
